module.exports = __webpack_public_path__ + "img/onlineDeclaration-exam-number1.4fd33eb6.jpg";